import { createAsyncThunk } from '@reduxjs/toolkit';
import { allPermissionsAPI } from './allPermissionsAPI';

export const getAllPermissions = createAsyncThunk('service/permission', async () => {
  try {
    const response = await allPermissionsAPI.getAllPermissions();
    return response.data;
  } catch (error) {
    console.error(error);
  }
});
